import { Box, TextField, IconButton } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';


const INPUT_STYLE = { style: { textAlign: 'center', padding: 0 } };

const QuantityControl = ({
  productId,
  type,
  quantity,
  handleQuantityChange,
  disabled = false,
}) => (
  <Box display="flex" alignItems="center">
    <IconButton
      size="small"
      color="primary"
      onClick={() => handleQuantityChange(productId, type, quantity - 1)}
      disabled={disabled}
    >
      <RemoveIcon />
    </IconButton>
    <TextField
      value={quantity}
      onChange={(e) => handleQuantityChange(productId, type, Math.max(0, parseInt(e.target.value, 10) || 0))}
      slotProps={{ htmlInput: INPUT_STYLE }}
      sx={{
        width: 36,
        mx: 1,
        '& .MuiInputBase-root': {
          height: 36,
          backgroundColor: quantity > 0 ? 'success.main' : quantity < 0 ? 'error.main' : 'inherit',
          color: quantity > 0 ? 'success.contrastText' : quantity < 0 ? 'error.contrastText' : 'inherit',
        },
      }}
    />
    <IconButton
      size="small"
      color="primary"
      onClick={() => handleQuantityChange(productId, type, quantity + 1)}
      disabled={disabled}
    >
      <AddIcon />
    </IconButton>
  </Box>
);

export default QuantityControl;
